import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer-container'>
       Usham Adhitya Luwang &copy; UAL . All rights reserved.

    </div>
  )
}

export default Footer
